// extracted by mini-css-extract-plugin
export default {"primeiraOpcao":"ListaSuspensa_primeiraOpcao__L8B-7"};